module.exports = __webpack_public_path__ + "img/perfectum.d81f66aa.svg";